import React, { useEffect } from 'react';
import MenuUser from '../../includes/menu/menuUser';
import DrawerShopSection from './DrawerShopSection';
import './SideDrawer.css';
import { elakayAutoText } from "../../includes/pageInside/dataElakay";


const SideDrawer = ({
  show,
  infoSource,
  click,
  enableDrawerAnimations = false,
  enableItemAnimations = false,
  enableHoverAnimations = false,
}) => {
  // Lock scroll on body and .elakayPage when drawer is open
  useEffect(() => {
    if (show) {
      const elakayPage = document.querySelector('.elakayPage');
      const scrollY = elakayPage ? elakayPage.scrollTop : window.scrollY;
      
      // Save scroll position
      document.body.dataset.scrollY = scrollY;
      
      // Lock body and html
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      
      // Lock .elakayPage (main scrollable container)
      if (elakayPage) {
        elakayPage.style.overflow = 'hidden';
      }
    } else {
      const savedScrollY = parseInt(document.body.dataset.scrollY || '0');
      const elakayPage = document.querySelector('.elakayPage');
      
      // Restore body and html
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      
      // Restore .elakayPage
      if (elakayPage) {
        elakayPage.style.overflow = '';
        elakayPage.scrollTop = savedScrollY;
      }
    }
    
    return () => {
      const elakayPage = document.querySelector('.elakayPage');
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      if (elakayPage) {
        elakayPage.style.overflow = '';
      }
    };
  }, [show]);

  return (
    <>
      {/* Backdrop overlay */}
      <div
        className={`drawer-backdrop ${show ? 'visible' : ''} ${!enableDrawerAnimations ? 'no-drawer-animation' : ''}`}
        onClick={click}
        aria-hidden="true"
      />

      {/* Drawer */}
      <nav
        className={`side-drawer ${show ? 'open' : ''} ${!enableDrawerAnimations ? 'no-drawer-animation' : ''} ${!enableItemAnimations ? 'no-item-animation' : ''} ${!enableHoverAnimations ? 'no-hover' : ''}`}
        aria-hidden={!show}
      >
        {/* Header with close button */}
        <div className="drawer-header">
          <button 
            className="drawer-close-btn"
            onClick={click}
            aria-label={elakayAutoText("h_6c9fc990898478", "Close menu")}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M18 6L6 18M6 6l12 12" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="drawer-content">
          <DrawerShopSection click={click} />
          <MenuUser 
            infoSource={infoSource}
            userInfo={infoSource.userInfo} 
            click={click} 
          />
        </div>

        {/* Decorative element */}
        <div className="drawer-decoration" aria-hidden="true">
          <div className="decoration-circle"></div>
          <div className="decoration-circle small"></div>
        </div>
      </nav>
    </>
  );
};

export default SideDrawer;